/*=============================================== DemoItem component ===============================================*/

import { useContext } from "react"
import { useLocation } from "react-router-dom"
import classNames from "classnames"
import { Text, capitalize, CodeContainer, Section } from "tsx-library-julseb"

import { LangContext } from "context"
import type { LangContextType } from "context"

import { StyledDemoItem, Content, Code } from "components/DemoItem/styles"
import type { DemoItemProps } from "components/DemoItem/types"

const DemoItem = ({
    item: { title, content, code, codeTs, intro },
}: DemoItemProps) => {
    const location = useLocation().pathname

    const { language } = useContext(LangContext) as LangContextType

    const titleDemo = title
        ? location === "/helpers/hooks"
            ? title
            : capitalize(title || "")
        : null

    const demo = () => (
        <StyledDemoItem className={classNames({ "no-content": !content })}>
            {content && <Content>{content}</Content>}

            {(code || codeTs) && (
                <Code>
                    <CodeContainer
                        language={
                            codeTs && language === "ts"
                                ? "typescript"
                                : "javascript"
                        }
                    >
                        {codeTs && language === "ts" ? codeTs : code}
                    </CodeContainer>
                </Code>
            )}
        </StyledDemoItem>
    )

    if (!title && !intro) return demo()

    return (
        <Section gap="xs">
            {title && <Text tag="h3">{titleDemo}</Text>}

            {intro && <Text>{intro}</Text>}

            {demo()}
        </Section>
    )
}

export default DemoItem
